import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import {
  COMPOSE_MOUNT_WITH_POST,
  composeMountWithPostActionCreator,
  composeMountWithCommentActionCreator,
  COMPOSE_MOUNT_WITH_COMMENT,
  COMPOSE_MOUNT_WITH_REPLY,
  composeMountWithReplyActionCreator,
} from 'actions/feedComposeActions'
import { of, empty } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { Store } from 'interfaces/state'
import { feedCommentsSelector, feedUserSelector } from 'selectors/feedSelectors'
import { Action } from 'actions'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { mentionize } from 'helpers/feedCommonHelpers'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { Post } from 'interfaces/feed'

const mountWithPostEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(
      filterRequestOfType(COMPOSE_MOUNT_WITH_POST, 'request'),
      mergeMap((action) => {
        const { params } = action.payload
        const { postUid } = params
        const state = store.getState()
        const post = getItemFromCollection<Post, 'uid'>(state.data.feed.allPosts, postUid)
        if (!post) {
          return empty()
        }

        return of(composeMountWithPostActionCreator.success(params, { post }))
      }),
    )

const mountWithCommentEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(
      filterRequestOfType(COMPOSE_MOUNT_WITH_COMMENT, 'request'),
      mergeMap((action) => {
        const { params } = action.payload
        const { commentUid } = params
        const state = store.getState()
        const comment = getItemFromCollection(state.data.feed.comments, commentUid)
        if (!comment) {
          return empty()
        }

        return of(composeMountWithCommentActionCreator.success(params, { comment }))
      }),
    )

const mountWithReplyEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(filterRequestOfType(COMPOSE_MOUNT_WITH_REPLY, 'request')).pipe(
      mergeMap((action) => {
        const { replyCommentUid, parentCommentUid } = action.payload.params
        const isFirstLevelComment = replyCommentUid === parentCommentUid

        let text = ''
        let mention
        if (!isFirstLevelComment) {
          const state = store.getState()
          const comments = feedCommentsSelector(state)
          const comment = getItemFromCollection(comments, replyCommentUid)
          if (!comment) {
            return empty()
          }

          const user = feedUserSelector(state, { userUid: comment.authorUid })
          if (!user) {
            return empty()
          }

          text = `${ mentionize(user.username) } `
          mention = {
            username: user.username,
            uid: user.uid,
          }
        }

        return of<Action>(
          composeMountWithReplyActionCreator.success(action.payload.params, {
            text,
            mention,
          }),
        )
      }))

export const composeMountEpic = combineEpics(
  mountWithPostEpic,
  mountWithCommentEpic,
  mountWithReplyEpic,
)

export default composeMountEpic
